import get from 'lodash.get';
import integrationTypes from '../constants/integration-types';

const getIntegrationType = (state) =>
  get(state, 'helpCenter.integrationType', integrationTypes.NONE);

export default getIntegrationType;
